function selectProduct() {
	document.querySelectorAll( '[data-model]' ).forEach( ( model ) => {
		model.removeAttribute( 'data-is-current' );
	} );

	const input = document.querySelector<HTMLInputElement>( 'input:checked.nightfall-3d-model__select-product__item__input' );
	if ( input ) {
		const model = document.querySelector( `[data-model="${input.value}"]` );
		model?.setAttribute( 'data-is-current', '' );
	}
}

function initNightfall3D() {
	document.querySelectorAll( '.nightfall-3d-model__select-product__item__input' ).forEach( ( input ) => {
		input.removeEventListener( 'change', selectProduct );
		input.addEventListener( 'change', selectProduct );
	} );
}

window.addEventListener( 'load', initNightfall3D );
document.addEventListener( 'readystatechange', initNightfall3D );
initNightfall3D();
